import { only } from "../../lib/base.js";
import { Configurable } from "../../lib/configurable.js";
import "deepmerge";
const topLevelDomain = "co.id";
const ID = {
  id_ID: only(
    "adidas",
    Configurable.props({
      topLevelDomain,
      sitePath: "id",
      locale: "id_ID"
    })
  ),
  en_ID: only(
    "adidas",
    Configurable.props({
      topLevelDomain,
      sitePath: "en",
      locale: "en_ID"
    })
  )
};
export {
  ID
};
//# sourceMappingURL=ID.js.map
